import {
  MOKA_INVENTORY_API,
  MOKA_SHADOW_TRAFFIC_INVENTORY_API,
  MOKA_PURCHASE_ORDER_API,
} from '../../constants';

export const V1_SUPPLIER = `${MOKA_INVENTORY_API}/v1/suppliers`;

export const V1_REACTOR_SUPPLIER = `${MOKA_SHADOW_TRAFFIC_INVENTORY_API}/v1/suppliers`;

export const V1_PURCHASE_ORDER_SUPPLIER = `${MOKA_PURCHASE_ORDER_API}/v1/suppliers`;

export const V1_SUPPLIER_BY_ID = (id) => `${V1_SUPPLIER}/${id}`;

export const V1_REACTOR_SUPPLIER_BY_ID = (id) => `${V1_REACTOR_SUPPLIER}/${id}`;

export const V1_EXPORT_SUPPLIER = `${V1_SUPPLIER}/export`;
